<template>
  <div id="app">
    <b-navbar toggleable="md" :type="theme" :variant="theme" v-show="isAuthenticated">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand>EventDB</b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/events">Evénements</b-nav-item>
          <b-nav-item-dropdown id="nav7_ddown" text="Paramètres" extra-toggle-classes="nav-link-custom" left>
            <b-dropdown-item v-show="theme == '' || theme == 'light'" @click.prevent="changeTheme('dark')"><font-awesome-icon icon="moon" /> Mode nuit</b-dropdown-item>
            <b-dropdown-item v-show="theme == 'dark'" @click.prevent="changeTheme('light')"><font-awesome-icon icon="sun" /> Mode jour</b-dropdown-item>
            <b-dropdown-item to="/password">Modifier son mot de passe</b-dropdown-item>
            <b-dropdown-divider v-show="role == 'admin'"></b-dropdown-divider>
            <b-dropdown-item to="/cities/list" v-show="role == 'admin'">Liste des villes</b-dropdown-item>
            <b-dropdown-item to="/schools/list" v-show="role == 'admin'">Liste des écoles</b-dropdown-item>
            <b-dropdown-item to="/establishments/list" v-show="role == 'admin'">Liste des établissements</b-dropdown-item>
            <b-dropdown-item to="/types/list" v-show="role == 'admin'">Liste des types</b-dropdown-item>
            <b-dropdown-item to="/labels/list">Liste des labels</b-dropdown-item>
            <b-dropdown-item to="/images/list">Liste des images</b-dropdown-item>
            <b-dropdown-item to="/users/list" v-show="role == 'admin'">Liste des utilisateurs</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item to="/parameters/list">Configuration page agenda</b-nav-item>
          <b-nav-item to="/import" v-show="role == 'admin'">Import</b-nav-item>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click.prevent="logout">Déconnexion</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <main role="main" class="container-fluid">
      <router-view/>
    </main><!-- /.container -->
    <footer class="text-muted" v-show="isAuthenticated">
      <hr />
      <b-container>
        <p class="text-center m-0 pb-3">IONIS Education Group &copy; 2018-{{ year }} <!--&ndash; EventDB 0.0.11 &ndash; <router-link to="/changelog"><a>Notes de version</a></router-link>--></p>
      </b-container>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import store from './components/Store'
import Vuex from 'vuex'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCookie from 'vue-cookie'

library.add(faMoon)
library.add(faSun)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueCookie)

export default {
  name: 'App',
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  store: store,
  computed: {
    ...Vuex.mapGetters(['access_token', 'active', 'domain', 'isAuthenticated', 'role', 'theme', 'userId']),
    darker () {
      return this.theme === 'dark' && this.isAuthenticated ? 'dark' : 'light'
    }
  },
  methods: {
    ...Vuex.mapActions(['addAccessToken', 'addEstablishment', 'addRole', 'addSchool', 'addTheme', 'addUserId']),
    changeTheme (theme) {
      this.addTheme(theme)
    },
    logout () {
      this.$http.post(this.domain + '/api/ionis/logout?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        if (response.status === 204 && response.ok) {
          this.addAccessToken('')
          this.addUserId('')
          this.addRole('')
          this.addEstablishment([])
          this.addSchool([])
          document.body.className = this.darker
          this.$router.push('/')
        }
      }, (response) => {
        response.json().then((data) => {

        })
      })
    }
  },
  mounted () {
    if (this.access_token !== '') {
      this.$http.get(this.domain + '/api/ionis/' + this.userId + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.addRole(data.role)
          document.body.className = this.darker
        })
      }, (response) => {
        if (!response.ok) {
          this.addAccessToken('')
          this.addUserId('')
          this.addRole('')
          this.addEstablishment([])
          this.addSchool([])
          document.body.className = this.darker
          this.$router.push('/')
        }
      })
    }
  },
  beforeUpdate () {
    if (this.access_token !== '') {
      document.body.className = this.darker
      this.$http.get(this.domain + '/api/ionis?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        this.$http.get(this.domain + '/api/ionis/' + this.userId + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            this.addRole(data.role)
          })
        }, (response) => {

        })
      }, (response) => {
        if (!response.ok) {
          this.addAccessToken('')
          this.addUserId('')
          this.addRole('')
          this.addEstablishment([])
          this.addSchool([])
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style>
@import "../node_modules/ladda/dist/ladda-themeless.min.css";
</style>

<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap.scss";

main {
  margin-top: 20px;
}

body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.beta {
  color: rgb(216, 116, 116);
}

.dark {
  // background: #32383e;
  background: #383d42;
  h1, h4, label, legend, li, p {
    color: #FFF;
  }
  hr {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

.required {
  &:after {
    content: '*';
    color: red;
  }
}

.form-control[readonly]:not(:disabled) {
  background: #FFF;
}
.vdp-datepicker__clear-button span i span {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 1.5rem;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue